import React, {Component, Fragment} from 'react'
import {jsonResponseHandler} from '../../utils/FetchHelper'
import * as InitStatus from "../../constants/common/InitializationStatus";
import If from "../common/control/If";
import RetryView from "../statistics/common/RetryView";
import Loading from "../common/Loading";
import { connect } from "react-redux";
import {addPrefix} from "../../utils/UriUtil";

@connect(state => ({
    dashboardErrorCount: state.statistics.dashboardErrorCount
}))
class DashboardRecentEntry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      initialized: InitStatus.INIT_READY,
      recentPosts: []
    }
  }

  // Mount후 최근게시글 정보 호출
  componentDidMount() {
    this.getRecentEntry();
  }

  // api 호출
  getRecentEntry = () => {
    const {dispatch} = this.props;
    this.setState({initialized: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix("/manage/statistics/dashboard/recentEntry.json"), {
        credentials: "include",
        headers: {"Content-Type": "application/json"},
        retries: 2,
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          this.setState({
            initialized: InitStatus.INIT_SUCCESS,
            recentPosts: res.data.result
          })
        })
        .catch(e => {
          console.log(e);
          this.setState({initialized: InitStatus.INIT_FAIL});
        });
    })
  };

  // max count
  parseOverCount(max, count) {
    return (count > max) ? `${max}+` : count;
  }

  // 리스트 Items
  renderItems(list) {
    return list.map((item, index) => {
      return <li key={index}>
        {item.thumbnail && this.renderThumbnailPost(item)}
        {!item.thumbnail && this.renderPost(item)}
      </li>
    });
  }

  // 일반 게시글 타입
  renderPost(item) {
    return <Fragment>
      <a href={item.permalink} target="_blank" className="link_post">
        <strong className="txt_vellip tit_top">{this.renderScheduled(item.isScheduled)}{item.title}</strong>
        <p className="txt_vellip txt_top">{item.summary}</p>
      </a>
      {this.renderBottomButtons(item)}
    </Fragment>
  }

  // 썸네일 타입
  renderThumbnailPost(item) {
    return <Fragment>
      <a href={item.permalink} target="_blank" className="link_post link_post_type2">
        <div className="wrap_thumb">
          <img src={item.thumbnail} width="217" height="126" className="thumb_img" alt=""/>
        </div>
        <div className="txt_post">
          <strong className="txt_vellip tit_top">{this.renderScheduled(item.isScheduled)}{item.title}</strong>
        </div>
      </a>
      {this.renderBottomButtons(item)}
    </Fragment>
  }

  // 예약발행
  renderScheduled(isScheduled) {
    return isScheduled ? <span className="info_status">[예약글]</span> : '';
  }


  // 게시글 하단 버튼 영역
  renderBottomButtons(item) {
    return <div className="wrap_writer">
      <span className="txt_writer">댓글 {this.parseOverCount(9999, item.countOfComments)}</span>
      <span className="txt_writer">공감 {this.parseOverCount(9999, item.reactionCounter.like)}</span>
      <a href={addPrefix(`/manage/statistics/entry/${item.id}`)} target="_blank" className="btn_post">통계</a>
    </div>;
  }


  // Empty
  renderEmpty() {
    return <Fragment>
      <p className="txt_none">작성된 글이 없습니다.</p>
      <a href={addPrefix("/manage/post")} className="link_none">새 글 쓰기</a>
    </Fragment>
  }

  // main Render
  render() {
    const {recentPosts, initialized} = this.state;
    const {isDoing, isEmpty, isFail} = InitStatus.init(initialized, recentPosts);

    return (
      <Fragment>
        <div className="post_main">
          <h4 className="tit_cont">최근 글</h4>
          <If condition={isFail}><div className="box_blog"><RetryView retryCallback={this.getRecentEntry}/></div></If>
          <If condition={isDoing}><div className="box_blog"><Loading/></div> </If>
          <If condition={!isEmpty}><ul className="list_top">{this.renderItems(recentPosts)}</ul> </If>
          <If condition={isEmpty}><div className="box_blog info_none">{this.renderEmpty()}</div> </If>
        </div>
      </Fragment>
    )
  }
}

export default DashboardRecentEntry
